document.querySelectorAll('.js-open-popup-form[data-popup]').forEach(btn => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();

        const popup = document.querySelector(`.js-popup-form[data-id="${btn.dataset.popup}"]`);
        popup?.classList.add('_is-open');

        if (popup?.dataset.src) {
            popup.querySelector('iframe')?.setAttribute('src', popup.dataset.src);
        }
    });
});

document.querySelectorAll('.js-close-popup-form').forEach(btn => {
    btn.addEventListener('click', (e) => {
        e.preventDefault();
        const popup = btn.closest('.js-popup-form');

        popup?.querySelector('iframe')?.setAttribute('src', '');
        popup?.classList.remove('_is-open');
    });
});
